import React, {Fragment} from "react";
import Save from "./Save";
import New from "./New";
import Delete from "./Delete";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems, actionButtons} = props;
    return <Fragment>
        {Array.isArray(actionButtons) ? actionButtons.map((i) => i) : actionButtons}
        <Save {...propsTop} />
        <New {...propsTop} />
        <Delete {...propsTop} />
    </Fragment>;
}